export const LOAD_USER_PROFILE = 'AuthProvider/LOAD_USER_PROFILE';
export const LOAD_USER_PROFILE_SUCCESS =
  'AuthProvider/LOAD_USER_PROFILE_SUCCESS';
export const LOAD_USER_PROFILE_FAIL = 'AuthProvider/LOAD_USER_PROFILE_FAIL';
export const LOGIN = 'AuthProvider/LOGIN';
export const SIGN_UP = 'AuthProvider/SIGN_UP';
export const LOGOUT = 'AuthProvider/LOGOUT';
